
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Lazyload, Dialog, Toast } from 'vant';
import { getVoteList } from '../api';

Vue.use(List).use(Lazyload).use(Dialog).use(Toast);

const reset = () => {
  return (
    target: { [key: string]: any },
    name: string,
    descriptor: { [key: string]: any },
  ) => {
    const fn = descriptor.value;
    descriptor.value = function reset() {
      this.loading = false;
      this.finished = false;
      this.page = 1;
      this.getListData = [];
      fn.call(this);
    };
  };
};

@Component
export default class VoteList extends Vue {
  @Prop() listType!: any;
  @Prop({ default: '' }) search!: any;

  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];

  get words() {
    return this.search;
  }
  // 初使加载
  async onLoad() {
    this.loading = true;
    const res = await getVoteList(this.listType, this.page, this.search);
    this.fetchListData(res);
  }
  fetchListData(res: any) {
    if (res.status === 1 || res.code === 500 || res.msg === '暂无数据') {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
      this.finished = false;
    }
    this.loading = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    this.$router.push({
      path: 'detail',
      query: {
        id: item.id,
      },
    });
    this.$emit('enterDetailPage', item.id);
  }
  @reset()
  @Watch('listType', {
    immediate: true,
  })
  onListTypeChanged() {
    // this.loading = false;
    // this.finished = false;
    // this.page = 1;
    // this.getListData = [];
    this.onLoad();
  }
  @reset()
  @Watch('search')
  onSearchChanged() {
    // this.loading = false;
    // this.finished = false;
    // this.page = 1;
    // this.getListData = [];
    this.onLoad();
  }
}
